// import { Buttonbar_profile } from "./Buttonbar_profile";
import { Footer } from "./Home/Footer";
import "./Profile_page1.css";
import { ProfilePic } from "./Profile_pic";
import { Profilesubhead } from "./Profile_subhead";

export const Profilepage1 = () => {
  return (
    <>
      <div className="profile_box">
        <div className="profile_head">Profile</div>
      </div>
      <ProfilePic />
      <Profilesubhead />
      <Footer></Footer>
    </>
  );
};
